export const filterPrice = (price) => {
  return price.toFixed(2)
}

export const checkOrderVerify = (order) => {
  let result = false
  const channel = order.payment && order.payment.channel
  if (!channel) return result
  if (order.step === 2) {
    result = true
  }
  return result
}

export const checkOrderRefund = (order) => {
  const amount = order.amount && order.amount.totalAmount
  const refund = order.amount && order.amount.refundAmount
  return amount > refund && ([2, 8].includes(order.step))
}

export const checkRefundAmount = (order) => {
  const { balanceAmount = 0, cardAmount = 0, discountAmount = 0, payAmount = 0, refundAmount = 0 } = order.amount
  const refund = balanceAmount + cardAmount + discountAmount + payAmount - refundAmount
  return refund
}